import { InfographicSize } from "../model/infographic-size.enum"

export const infographicTemplatePrompt = {
    1: {
        [InfographicSize.RATIO_16_9]: {
            block: [
                { max_topic_char: 24, max_content_char: 150 },
                { max_topic_char: 24, max_content_char: 150 },
                { max_topic_char: 34, max_content_char: 320 },
            ],
            block_max_title_char: 47,
            block_max_quote_char: 138,
        },
        [InfographicSize.RATIO_9_16]: {
            block: [
                { max_topic_char: 20, max_content_char: 165 },
                { max_topic_char: 20, max_content_char: 165 },
                { max_topic_char: 34, max_content_char: 320 },
                { max_topic_char: 20, max_content_char: 175 },
            ],
            block_max_title_char: 47,
            block_max_quote_char: 138,
        },
        [InfographicSize.RATIO_1_1]: {
            block: [
                { max_topic_char: 28, max_content_char: 240 },
                { max_topic_char: 30, max_content_char: 230 },
            ],
            block_max_title_char: 38,
            block_max_quote_char: 100,
        },
        [InfographicSize.A4]: {
            block: [
                { max_topic_char: 25, max_content_char: 180 },
                { max_topic_char: 25, max_content_char: 136 },
                { max_topic_char: 30, max_content_char: 200 },
            ],
            block_max_title_char: 30,
            block_max_quote_char: 105,
        },
        [InfographicSize.A3]: {
            block: [
                { max_topic_char: 23, max_content_char: 177 },
                { max_topic_char: 23, max_content_char: 134 },
                { max_topic_char: 30, max_content_char: 206 },
            ],
            block_max_title_char: 27,
            block_max_quote_char: 100,
        },
        [InfographicSize.POSTER]: {
            block: [
                { max_topic_char: 25, max_content_char: 180 },
                { max_topic_char: 25, max_content_char: 132 },
                { max_topic_char: 30, max_content_char: 200 },
            ],
            block_max_title_char: 27,
            block_max_quote_char: 105,
        },
    },
    2: {
        [InfographicSize.RATIO_16_9]: {
            block: [
                { max_topic_char: 24, max_content_char: 204 },
                { max_topic_char: 18, max_content_char: 160 },
                { max_topic_char: 24, max_content_char: 205 },
                { max_topic_char: 27, max_content_char: 230 },
                { max_topic_char: 27, max_content_char: 150 },
            ],
            block_max_title_char: 45,
            block_max_quote_char: 100,
        },
        [InfographicSize.RATIO_9_16]: {
            block: [
                { max_topic_char: 24, max_content_char: 180 },
                { max_topic_char: 16, max_content_char: 210 },
                { max_topic_char: 27, max_content_char: 240 },
                { max_topic_char: 28, max_content_char: 160 },
            ],
            block_max_title_char: 25,
            block_max_quote_char: 100,
        },
        [InfographicSize.RATIO_1_1]: {
            block: [
                { max_topic_char: 24, max_content_char: 128 },
                { max_topic_char: 18, max_content_char: 200 },
                { max_topic_char: 25, max_content_char: 150 },
            ],
            block_max_title_char: 27,
            block_max_quote_char: 100,
        },
        [InfographicSize.A4]: {
            block: [
                { max_topic_char: 24, max_content_char: 127 },
                { max_topic_char: 15, max_content_char: 205 },
                { max_topic_char: 25, max_content_char: 152 },
            ],
            block_max_title_char: 27,
            block_max_quote_char: 106,
        },
        [InfographicSize.A3]: {
            block: [
                { max_topic_char: 24, max_content_char: 128 },
                { max_topic_char: 16, max_content_char: 200 },
                { max_topic_char: 25, max_content_char: 150 },
            ],
            block_max_title_char: 30,
            block_max_quote_char: 100,
        },
        [InfographicSize.POSTER]: {
            block: [
                { max_topic_char: 24, max_content_char: 135 },
                { max_topic_char: 18, max_content_char: 198 },
                { max_topic_char: 25, max_content_char: 150 },
            ],
            block_max_title_char: 27,
            block_max_quote_char: 104,
        },
    },
    3: {
        [InfographicSize.RATIO_16_9]: {
            block: [
                { max_topic_char: 70, max_content_char: 420 },
                { max_topic_char: 21, max_content_char: 280 },
                { max_topic_char: 21, max_content_char: 280 },
                { max_topic_char: 36, max_content_char: 740 },
                { max_topic_char: 36, max_content_char: 270 },
            ],
            block_max_title_char: 27,
            block_max_quote_char: 0,
        },
        [InfographicSize.RATIO_9_16]: {
            block: [
                { max_topic_char: 70, max_content_char: 360 },
                { max_topic_char: 21, max_content_char: 280 },
                { max_topic_char: 21, max_content_char: 280 },
                { max_topic_char: 40, max_content_char: 440 },
                { max_topic_char: 40, max_content_char: 440 },
            ],
            block_max_title_char: 27,
            block_max_quote_char: 0,
        },
        [InfographicSize.RATIO_1_1]: {
            block: [
                { max_topic_char: 70, max_content_char: 360 },
                { max_topic_char: 21, max_content_char: 280 },
                { max_topic_char: 21, max_content_char: 280 },
            ],
            block_max_title_char: 27,
            block_max_quote_char: 0,
        },
        [InfographicSize.A4]: {
            block: [
                { max_topic_char: 77, max_content_char: 366 },
                { max_topic_char: 21, max_content_char: 280 },
                { max_topic_char: 21, max_content_char: 280 },
                { max_topic_char: 40, max_content_char: 440 },
            ],
            block_max_title_char: 27,
            block_max_quote_char: 0,
        },
        [InfographicSize.A3]: {
            block: [
                { max_topic_char: 70, max_content_char: 360 },
                { max_topic_char: 21, max_content_char: 280 },
                { max_topic_char: 21, max_content_char: 280 },
                { max_topic_char: 40, max_content_char: 440 },
            ],
            block_max_title_char: 27,
            block_max_quote_char: 0,
        },
        [InfographicSize.POSTER]: {
            block: [
                { max_topic_char: 77, max_content_char: 366 },
                { max_topic_char: 21, max_content_char: 280 },
                { max_topic_char: 21, max_content_char: 280 },
                { max_topic_char: 40, max_content_char: 440 },
            ],
            block_max_title_char: 27,
            block_max_quote_char: 0,
        },
    }
}